"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7118,7026,1756,6052],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 57026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/select.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx


// src/select-field.tsx

var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: cx("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
SelectField.displayName = "SelectField";

// src/select.tsx
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  var _a;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = split(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = {
    paddingEnd: "2rem",
    ...styles.field,
    _focus: {
      zIndex: "unset",
      ...(_a = styles.field) == null ? void 0 : _a["_focus"]
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": dataAttr(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
Select.displayName = "Select";
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
SelectIcon.displayName = "SelectIcon";



/***/ }),

/***/ 71756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75159);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3382);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37026);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29438);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);








const AutoPromo = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    href: item.link || '',
    title: item.linkText || 'Scopri di più',
    bg: item.layout === 'outline' ? 'baseWhite' : 'primaryGreen.800',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      bg: item.layout === 'outline' ? 'baseWhite' : 'primaryGreen.800',
      bgImage: item.image ? `url(${item.image})` : '',
      bgPosition: item.image ? '95% 95%' : '',
      bgRepeat: item.image ? 'no-repeat' : '',
      bgSize: item.image ? '20%' : '',
      p: "l",
      h: "370px",
      borderRadius: 10,
      overflow: "hidden",
      borderColor: item.layout === 'outline' ? src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.colors.borders.grey */ .r.colors.borders.grey : 'primaryGreen.800',
      borderWidth: 1,
      boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.shadows.cards */ .r.shadows.cards,
      textAlign: "left",
      color: item.layout === 'outline' ? 'baseDark' : 'baseWhite',
      position: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .LinkOverlay */ .AB, {
        href: item.link,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
          fontSize: "1.75rem",
          children: item.title
        })
      }), item.text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        marginTop: "s",
        fontFamily: "Montserrat-Medium",
        fontSize: "1.125rem",
        pb: "s",
        children: item.text
      }), item.listItems && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        items: item.listItems,
        color: "baseDark"
      }), item.link && item.linkText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .LinkOverlay */ .AB, {
        href: item.link,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
          title: item.linkText,
          fontSize: "m",
          color: item.layout === 'outline' ? 'baseDark' : 'baseWhite',
          children: [item.linkText, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__/* .ArrowForwardIcon */ .mr, {})]
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (AutoPromo);

/***/ }),

/***/ 89000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const OfferList = _ref => {
  let {
    items
  } = _ref;
  const data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx,
      "url": item
    }))
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OfferList);

/***/ }),

/***/ 98681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var src_components_NltOffers___WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42702);
/* harmony import */ var src_components_NltOffers___WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71756);
/* harmony import */ var src_components_NltOffers___WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26869);
/* harmony import */ var src_utils_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13925);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71033);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89000);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);













const Pagination = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(6319), __webpack_require__.e(3344), __webpack_require__.e(804), __webpack_require__.e(1937), __webpack_require__.e(285)]).then(__webpack_require__.bind(__webpack_require__, 90285)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(90285)]
  }
});
const MobileActionBar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3344), __webpack_require__.e(3292), __webpack_require__.e(9653), __webpack_require__.e(1412)]).then(__webpack_require__.bind(__webpack_require__, 57347)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(57347)]
  }
});
const HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(7620), __webpack_require__.e(6717)]).then(__webpack_require__.bind(__webpack_require__, 83935)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(83935)]
  }
});

const LandingBrandNltOffersContainer = _ref => {
  let {
    slug,
    page
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  const filterMenuIsOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.nlt.filterMenuIsOpen);
  const offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.nlt.filteredOffers);
  const otherOffers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.nlt.offers);

  const onPaginatorClickHandler = page => dispatch((0,src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_6__/* .setListingPage */ .Dx)(page));

  (0,src_utils_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useBackButton */ .Kx)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
    px: "l",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_9__/* .LinkRel */ .M, {
      rel: "canonical",
      href: `https://www.carplanner.com/noleggio-a-lungo-termine/${slug}${page && page > 1 ? `?pagina=${page}` : ''}`
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      items: offers.items.map(item => ['https://carplanner.com/noleggio-a-lungo-termine/', item.brandCode, '/', item.modelCode, '/', item.code, '?deposit=', item.deposit, '&contractLength=', item.contractLength, '&annualMileage=', item.annualMileage].join(''))
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_11__["default"], {
      offersCount: offers.items.length
    }), offers.items && offers.items.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
        templateColumns: {
          md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
          lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`
        },
        gap: 6,
        pt: "l",
        pb: "24px",
        children: [offers.items.map(item => {
          return item.code === 'auto-promo' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
            display: "inline-grid",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_12__["default"], {
              item: item
            })
          }, `${item.code}- ${item.title} `) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
            display: "inline-grid",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_13__["default"], {
              item: item
            })
          }, item.code);
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
          colSpan: {
            md: filterMenuIsOpen ? 2 : 3,
            lg: filterMenuIsOpen ? 3 : 4
          },
          mt: "-2",
          textAlign: "left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Pagination, {
            currentPage: offers.currentPage,
            perPage: offers.pageSize,
            total: offers.results,
            onClick: onPaginatorClickHandler
          })
        }, "load-more")]
      }), isMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(MobileActionBar, {})]
    }) : isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
      pb: "24px",
      px: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
        as: "h3",
        px: "l",
        pt: "l",
        fontSize: "2xl",
        fontFamily: "Montserrat-SemiBold",
        children: t('nltPage:notFound')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeOffersList, {
        action: t('indexPage:nlt_offers.action'),
        alt: t('indexPage:nlt_offers.alt'),
        bgColor: "baseNeutral.100",
        href: "/noleggio-a-lungo-termine",
        offers: otherOffers,
        numPerView: filterMenuIsOpen ? 3 : 4
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
      templateColumns: {
        md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
        lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`
      },
      gap: 6,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
          as: "h3",
          fontSize: "2xl",
          fontFamily: "Montserrat-SemiBold",
          children: t('nltPage:notFound')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeOffersList, {
          w: "100%",
          action: t('indexPage:nlt_offers.action'),
          alt: t('indexPage:nlt_offers.alt'),
          bgColor: "baseNeutral.100",
          href: "/noleggio-a-lungo-termine",
          offers: otherOffers,
          numPerView: filterMenuIsOpen ? 3 : 4,
          paddingLeft: "0px",
          paddingRight: "0px"
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LandingBrandNltOffersContainer);

/***/ }),

/***/ 29160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const SuccessIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#41A476",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M9 1.5c4.142 0 7.5 3.358 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5-4.142 0-7.5-3.358-7.5-7.5 0-4.142 3.358-7.5 7.5-7.5zm0 1.452C5.657 2.952 2.952 5.657 2.952 9S5.657 15.048 9 15.048 15.048 12.343 15.048 9 12.343 2.952 9 2.952zm4.24 3.94c.141.141.14.371-.002.512l-5.22 5.178c-.142.141-.371.14-.513-.002L4.76 9.812c-.141-.142-.14-.372.002-.513l.687-.682c.142-.14.372-.14.513.003l1.809 1.822 4.274-4.24c.143-.141.372-.14.514.002l.681.687z",
        transform: "translate(-86 -2134) translate(0 1936) translate(86 96) translate(0 99) translate(0 3)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (SuccessIcon);

/***/ }),

/***/ 37026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const CardLink = _ref => {
  let {
    href,
    onClick,
    title,
    bg,
    children
  } = _ref;
  return href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .LinkBox */ .fG, {
    title: title,
    borderRadius: 10,
    bg: bg || 'baseWhite',
    pb: "l",
    overflow: "hidden",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.borders.grey */ .r.colors.borders.grey,
    borderWidth: 1,
    boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.shadows.cards */ .r.shadows.cards,
    _hover: {
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    children: children
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    title: title,
    onClick: onClick,
    cursor: "pointer",
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CardLink);

/***/ }),

/***/ 29438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29160);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["items", "color", "fontSize", "fontFamily", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const StyledList = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC).withConfig({
  componentId: "sc-b5lt8m-0"
})(["& svg{display:inline;}"]);

const ListWithIcons = _ref => {
  let {
    items,
    color,
    fontSize,
    fontFamily,
    icon
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
    paddingY: "l",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .List */ .aV, {
      spacing: 3,
      children: items.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledList, _objectSpread(_objectSpread({
        color: color || 'baseWhite',
        fontFamily: fontFamily || 'Montserrat-SemiBold',
        fontSize: fontSize || '1rem',
        lineHeight: "22.8px",
        letterSpacing: "0.3px",
        textAlign: "left",
        py: "auto"
      }, props), {}, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListIcon */ .DE, {
          as: icon || src_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
          fontSize: "1rem",
          lineHeight: "22.8px"
        }), ` ${item}`]
      }), item))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ListWithIcons);

/***/ }),

/***/ 29590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tH": function() { return /* binding */ rentOfferToPageMeta; },
  "ck": function() { return /* binding */ rentOfferToProductItem; },
  "np": function() { return /* binding */ sellOfferToPageMeta; },
  "rW": function() { return /* binding */ sellOfferToProductItem; }
});

// UNUSED EXPORTS: rentOfferToOfferData, rentOfferValue, sellOfferToOfferData, sellOfferValue, toNumber

// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/utils/gtm/naming.ts
var naming = __webpack_require__(31067);
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.json
var brandRules_namespaceObject = JSON.parse('{"fiat":{"rpl":22,"offerCustomerType":"B2C","offerType":"Finanziamento"},"jeep":{"rpl":27.5,"offerCustomerType":"B2C","offerType":"Finanziamento"},"bmw":{"offerCustomerType":"B2C","offerType":"Leasing"},"toyota":{"offerCustomerType":"B2B","offerType":"Finanziamento"},"peugeot":{"offerCustomerType":"B2C","offerType":"Finanziamento"}}');
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Valori commerciali che variano per brand automotive.
 *
 * Oggi vivono in un JSON versionato ([brandRules.json](./brandRules.json)): sono
 * accordi commerciali che cambiano di rado e che il backend non espone. La
 * lettura passa da `getBrandRules`, così che il giorno in cui l'offers-explorer
 * restituirà questi campi basti cambiare questa implementazione senza toccare
 * i punti di chiamata.
 *
 * Un brand non mappato NON eredita un rpl inventato: la chiave viene omessa.
 */



const DEFAULT_RULES = {
  offerCustomerType: 'B2C',
  offerType: constants/* DEFAULT_OFFER_TYPE */.OJ
};
function getBrandRules(brandCode) {
  const key = (0,naming/* slugSegment */.nL)(brandCode);
  const brandRules = key ? brandRules_namespaceObject[key] : undefined;
  return _objectSpread(_objectSpread({}, DEFAULT_RULES), brandRules);
}
;// CONCATENATED MODULE: ./src/utils/gtm/mappers.ts
/**
 * Dai DTO dell'offers-explorer agli oggetti dello schema dataLayer.
 *
 * Attenzione alla semantica dei prezzi, invertita rispetto a quella intuitiva:
 * `ecommerce.items[].price` è il prezzo di LISTINO, mentre `ecommerce.value` è
 * il prezzo promozionale/corrente. GA4 non sottrae mai `discount` da `price`.
 */



/** Converte in numero positivo; qualunque altro caso diventa `undefined` (chiave omessa). */
function toNumber(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = typeof value === 'number' ? value : parseFloat(`${value}`);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

const absoluteUrl = path => path ? `${constants/* SITE_ORIGIN */.yp}${path.split('?')[0].split('#')[0]}` : undefined;

const withQuery = path => path ? `${constants/* SITE_ORIGIN */.yp}${path}` : undefined;

const sellOfferPath = offer => {
  var _offer$vehicle, _offer$vehicle2;

  return `/offerte-auto/${((_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.brandCode) ?? offer.brandCode}/${((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.modelCode) ?? offer.modelCode}/${offer.code}`;
};

const rentOfferPath = offer => {
  var _offer$vehicle3, _offer$vehicle4;

  return `/noleggio-a-lungo-termine/${((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.brandCode) ?? offer.brandCode}/${((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.modelCode) ?? offer.modelCode}/${offer.code}`;
};

function sellOfferToProductItem(offer) {
  var _vehicle$engine;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? offer.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine = vehicle.engine) === null || _vehicle$engine === void 0 ? void 0 : _vehicle$engine.fuel;
  const canonicalPath = path || sellOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: vehicle === null || vehicle === void 0 ? void 0 : vehicle.category,
    item_category4: detail.year ? `${detail.year}` : undefined,
    item_category5: version,
    price: toNumber(offer.price),
    currency: constants/* CURRENCY */.wA,
    discount: toNumber(detail.priceReduction),
    image_url: detail.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function rentOfferToProductItem(offer) {
  var _vehicle$engine2, _detail$images, _detail$images$;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const item = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? item.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? item.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? item.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine2 = vehicle.engine) === null || _vehicle$engine2 === void 0 ? void 0 : _vehicle$engine2.fuel;
  const canonicalPath = path || rentOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category) ?? item.category,
    item_category5: version,
    // Il noleggio non espone un prezzo di listino del veicolo: resta omesso.
    price: toNumber(detail.specialPrice),
    currency: constants/* CURRENCY */.wA,
    image_url: ((_detail$images = detail.images) === null || _detail$images === void 0 ? void 0 : (_detail$images$ = _detail$images[0]) === null || _detail$images$ === void 0 ? void 0 : _detail$images$.src) ?? item.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function sellOfferToOfferData(offer) {
  var _offer$vehicle5;

  const brandCode = ((_offer$vehicle5 = offer.vehicle) === null || _offer$vehicle5 === void 0 ? void 0 : _offer$vehicle5.brandCode) ?? offer.brandCode;
  const rules = getBrandRules(brandCode);
  return {
    offer_type: rules.offerType,
    offer_customer_type: rules.offerCustomerType,
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
function rentOfferToOfferData(offer) {
  return {
    offer_type: constants/* RENT_OFFER_TYPE */.y,
    offer_customer_type: offer.customerType === 'piva' ? 'B2B' : 'B2C',
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
/** Prezzo promozionale/corrente del veicolo. */

const sellOfferValue = offer => toNumber(offer.specialPrice) ?? toNumber(offer.price);
/** Per il noleggio l'unico valore economico esposto è il canone mensile. */

const rentOfferValue = offer => toNumber(offer.monthlyRate);

/** Meta di pagina per la VDP sell, pronta per `useGtmPage`. */
function sellOfferToPageMeta(offer) {
  var _vehicle$engine3;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  const brandCode = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode) ?? offer.brandCode;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand,
    model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine3 = vehicle.engine) === null || _vehicle$engine3 === void 0 ? void 0 : _vehicle$engine3.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(brandCode).rpl,
    productItem: sellOfferToProductItem(offer, {
      path
    }),
    offerData: sellOfferToOfferData(offer),
    value: sellOfferValue(offer)
  };
}
/** Meta di pagina per la VDP noleggio, pronta per `useGtmPage`. */

function rentOfferToPageMeta(offer) {
  var _vehicle$engine4;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand,
    model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine4 = vehicle.engine) === null || _vehicle$engine4 === void 0 ? void 0 : _vehicle$engine4.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode).rpl,
    productItem: rentOfferToProductItem(offer, {
      path
    }),
    offerData: rentOfferToOfferData(offer),
    value: rentOfferValue(offer)
  };
}

/***/ }),

/***/ 13925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ useBackButton; },
/* harmony export */   "WQ": function() { return /* binding */ useCustomizedNltOffer; },
/* harmony export */   "gU": function() { return /* binding */ useSelectableDeposits; },
/* harmony export */   "rS": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* unused harmony export useQuerystringToFilterOffers */
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70461);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26869);
/* harmony import */ var src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37398);
/* harmony import */ var src_utils_querystring__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89363);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const useQuerystringToFilterOffers = domain => {
  const dispatch = useDispatch();
  const performSearchOffers = domain === 'nlt' ? nltPerformSearchOffers : sellPerformSearchOffers;
  useEffect(() => {
    if (getSearchParams().size > 0) {
      dispatch(performSearchOffers());
    }
  }, []);
};
const useBackButton = () => {
  const onPopState = () => {
    if ((0,src_utils_querystring__WEBPACK_IMPORTED_MODULE_4__/* .getSearchParams */ .Qw)().size > 0) {
      location.reload();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  });
};
const useTracking = () => {
  const {
    query
  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  const {
    0: validQuery,
    1: setValidQuery
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
  const [allCookies, setCookie, removeCookie] = (0,react_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(['CP_TRACKER']);
  const path = '/';
  const today = new Date();
  const validity = parseInt("15");
  const expires = new Date(today.setDate(today.getDate() + validity));
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setValidQuery(query);
  }, [query]);

  const trackingData = () => allCookies['CP_TRACKER'];

  const setTracking = () => {
    const {
      utm_source: source = null,
      utm_medium: medium = null,
      utm_ref: referrer = null,
      utm_campaign: campaign = null,
      utm_campaign_date: campaign_date = null
    } = _objectSpread(_objectSpread({}, query), validQuery);

    if ((source || medium || referrer) && (typeof allCookies['CP_TRACKER'] === 'undefined' || !allCookies['CP_TRACKER'])) {
      setCookie('CP_TRACKER', {
        source,
        referrer,
        medium,
        campaign,
        campaign_date
      }, {
        path,
        expires
      });
    }
  };

  const removeTracking = () => removeCookie('CP_TRACKER');

  return [setTracking, removeTracking, trackingData];
};
const useCustomizedNltOffer = offerData => {
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
  const customizedOffer = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(state => state.nlt.customizedOffer);
  const variations = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getAllOfferVariations */ .P9)(offerData), [offerData]);
  const defaultOffer = {
    code: offerData.code,
    contractLength: offerData.contractLength,
    annualMileage: offerData.annualMileage,
    deposit: offerData.deposit,
    monthlyRate: offerData.monthlyRate,
    variationId: 0
  };
  /* Ignoriamo la personalizzazione di un'altra offerta rimasta in store */

  const offer = customizedOffer && customizedOffer.code === offerData.code ? _objectSpread(_objectSpread({}, defaultOffer), customizedOffer) : defaultOffer;

  const getMonthlyRate = (contractLength, annualMileage, deposit) => (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getVariationPriceFromCombination */ .VI)(variations, contractLength, annualMileage, deposit);

  const selectVariationItem = (param, value) => {
    const selected = _objectSpread({}, offer);

    switch (param) {
      case 'duration':
        selected.contractLength = value;
        break;

      case 'distance':
        selected.annualMileage = value;
        break;

      case 'deposit':
        selected.deposit = value;
        break;

      default:
        return;
    }

    const {
      contractLength,
      annualMileage,
      deposit
    } = selected;
    dispatch((0,src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_7__/* .setCustomizedOffer */ .qN)(_objectSpread(_objectSpread({}, selected), {}, {
      monthlyRate: getMonthlyRate(contractLength, annualMileage, deposit),
      variationId: (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getVariationIdFromCombination */ .$7)(variations, contractLength, annualMileage, deposit)
    })));
  };

  return {
    offer,
    variations,
    getMonthlyRate,
    selectVariationItem
  };
};
const useSelectableDeposits = offerData => {
  const {
    offer,
    getMonthlyRate,
    selectVariationItem,
    variations
  } = useCustomizedNltOffer(offerData);
  const {
    deposits
  } = (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getOfferVariationsGrouped */ .Mi)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .searchVariations */ .$e)(variations, offer.contractLength, offer.annualMileage, offer.deposit));

  const monthlyRateFromDeposit = deposit => {
    const monthlyRate = getMonthlyRate(offer.contractLength, offer.annualMileage, deposit);
    return monthlyRate === null || typeof monthlyRate === 'undefined' ? null : monthlyRate;
  };

  const selectableDeposits = deposits.filter(deposit => deposit === offer.deposit || monthlyRateFromDeposit(deposit) !== null).sort((depositA, depositB) => depositA - depositB);
  return {
    offer,
    selectableDeposits,
    hasDepositChoice: selectableDeposits.length > 1,
    monthlyRateFromDeposit,
    selectVariationItem
  };
};

/***/ }),

/***/ 70461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie.parse(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);